import React from 'react'
import useStore from '../../../../ProductStore/Store'
import styles from './styles.module.css'
import uploadIcon from '../../../../../img/uploadSVG.svg'

function ThirdRowBoxes () {
  const {
    isQueryLoading,
    setBrand,
    setName,
    setRequiredFields,
    setTaxonomy,
    setCategoryWildCard,
    setColor,
    setCategoriesWithParenthesis,
    setFeaturesWithKey
  } = useStore()

  const onClickSearcSpecificSmartphone = () => {
    if (isQueryLoading) return
    // "query": "brand:\"Google\" AND name:\"Pixel 8\" AND categories:*phones AND colors:\"black\" AND prices:*
    setBrand('Google')
    setName('Pixel 8')
    setCategoryWildCard('*phones')
    setRequiredFields(['prices'])
    setColor('black')
  }
  const onClickSubwayLocation = () => {
    // "query": "categories:(*women* AND *clothing*) AND features.key:*material*",
    if (isQueryLoading) return
    setCategoriesWithParenthesis('*women* AND *clothing*')
    setFeaturesWithKey('*material*')
  }
  const onClickTacoBellLocation = () => {
    // "query": "taxonomy:\"grocery & gourmet food > alcoholic beverages > wine\""
    if (isQueryLoading) return
    setTaxonomy('grocery & gourmet food > alcoholic beverages > wine')
  }

  return (
    <section>
      <div className={styles.jobTitlePeopleContainer}>
        {/* <h2 className={styles.jobTitlePeopleTitle}>Search example</h2> */}
        <div className={styles.jobTitlePeopleValues}>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            // className={styles.jobTitlePeopleItem}
            onClick={onClickSearcSpecificSmartphone}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>
                Search for a specific smartphone model
              </span>
              <p className={styles.jobTitlePeopleText}>
                Search google pixel 8, color black, & with pricing
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            // className={styles.jobTitlePeopleItem}
            onClick={onClickSubwayLocation}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>
                Clothing material data
              </span>
              <p className={styles.jobTitlePeopleText}>
                Search for clothing material data
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickTacoBellLocation}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>
                Build a database of wines
              </span>
              <p className={styles.jobTitlePeopleText}>
                Create a product data catalog of wines
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ThirdRowBoxes
